// extracted by mini-css-extract-plugin
module.exports = {"container":"jw-z","recos":"kw-z","productCardOverride":"lw-z"};